import * as i0 from "@angular/core";
var SlugService = /** @class */ (function () {
    function SlugService() {
    }
    SlugService.prototype.getSlug = function () {
        return location.hostname.split('.')[0];
    };
    SlugService.prototype.isOldHostname = function () {
        return location.hostname === 'fornecedores.fieldcontrol.com.br';
    };
    SlugService.prototype.isFieldControlAppBr = function () {
        return location.hostname.endsWith('fieldcontrol.app.br');
    };
    SlugService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SlugService_Factory() { return new SlugService(); }, token: SlugService, providedIn: "root" });
    return SlugService;
}());
export { SlugService };
